import { createSlice } from "@reduxjs/toolkit";
import { decryptToken } from "../utils/tokenSecure";
import { userInfo } from "os";
import { UserInfo } from "../types/userInfo";

const initialState = {
  userInfo: { personalThread: false, "cognito:username": "" },
  tokenMetadata: {},
  stripe: {paymentLinks: []},
};

export const metaDataSlice = createSlice({
  name: "metaData",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state = {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.payload,
        },
      };
      if (
        action.payload.personalThread ||
        action.payload.personalThread == false
      ) {
        let userInfo: UserInfo | null = null;
        const storedUserInfo = localStorage.getItem("userInfo");
        if (storedUserInfo) {
          try {
            userInfo = JSON.parse(storedUserInfo);
          } catch (err) {
            console.error("Invalid userInfo JSON:", err);
          }
        }
        const payload = {
          ...userInfo,
          personalThread: action.payload.personalThread,
        };
        localStorage.setItem("userInfo", JSON.stringify(payload));
      }
      return state;
    },
    setTokenMetadata: (state, action) => {
      state = {
        ...state,
        tokenMetadata: { ...state.tokenMetadata, ...action.payload },
      };
      return state;
    },
    setStripeMetadata: (state, action) => {
      state = {
        ...state,
        stripe: { ...state.stripe, ...action.payload },
      };
      return state;
    },
    resetMetaData: (state) => {
      state = initialState;
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, resetMetaData, setTokenMetadata, setStripeMetadata } =
  metaDataSlice.actions;

export default metaDataSlice.reducer;
